<template>
  <section class="card-goal">
    <h4 class="card-goal-text">
      {{ $t('comp.card.goal.title') }}
    </h4>
    <p class="card-goal-text" v-html="goalHtml"></p>
  </section>
</template>

<script>
export default {
  name: 'card-goal',

  props: [
    'goal',
  ],

  computed: {
    goalHtml() {
      return this.goal && this.goal.replace(/\n/g, '<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/components/_breakpoints';

  .card-goal {
    margin-bottom: 16px;
    background-color: transparent;
    border-color: transparent;

    .card-goal-text {
      color: #ffffff;
      font-size: 17px;
      font-weight: 100;

      @media (min-width: $desktop-breakpoint) {
        font-size: 20px;
      }
    }
  }
</style>
